import { ref } from '@vue/composition-api'
import { useEventBus } from '@vueuse/core'
import customPush from 'custom-push'
import parsePushData from 'custom-push/pushParser/parsePushData'
import parseTopicInfo from 'custom-push/pushParser/parseTopicInfo'
import eventBus from '@ms/utils/event-bus.js'
import { isLiveMatch, isPrematch } from '../status'

const isValidMatch = (status) => [0, 1, 2, 7].includes(status)

const subMatchPush = ({ sportId, categoryId, tournamentId, eventId }, callback = null, isSub = true) => {
  // 订阅参数
  const pushOption = {
    type: 1,
    sportId,
    categoryId,
    tournamentId,
    eventId
  }
  customPush.pushTopic(pushOption, callback, isSub)
}

// 更新 match 比赛信息
const generateUpdateMatch =
  (match = {}, matchPushTome) =>
  (data) => {
    const pushData = JSON.parse(data)
    const eventInfo = parsePushData(pushData, 'event')
    const topicInfo = parseTopicInfo(pushData.topic, 'event')
    // console.log('push match:', eventInfo)
    if (!eventInfo || match.eventId !== topicInfo.eventId) return

    let { topic, pushTime, bmLcooCount: marketsCount, ...restEventInfo } = eventInfo // eslint-disable-line
    delete eventInfo.bmLcooCount
    pushTime = Number(pushTime)
    // 网络延迟可能导致后收到的数据不是最新的
    if (matchPushTome && matchPushTome > pushTime) return

    const isPrematchMatchOfOld = isPrematch(match.status)
    const isLiveMatchOfNew = isLiveMatch(restEventInfo.status)
    Object.assign(match, { ...restEventInfo, marketsCount })
    matchPushTome.value = pushTime

    if (!isValidMatch(match.status)) {
      eventBus.$emit('matchEnd', match.eventId, match.tournamentId)
    }

    if (isPrematchMatchOfOld && isLiveMatchOfNew) {
      console.log('-------------------> ON_MATCH_CHANGED_TO_LIVE', match.eventId)
      useEventBus('ON_MATCH_CHANGED_TO_LIVE').emit({
        eventId: match.eventId,
        sportId: match.sportId
      })
    }
  }

export default function useMatchPush(event, isSubMatch = true) {
  if (!isSubMatch) return [event, null]
  if (!event.betStatus) {
    Object.assign(event, { betStatus: 0 })
  }
  const matchPushTome = ref(0)
  const updateMatch = generateUpdateMatch(event, matchPushTome)

  const subMatch = (isSub = true) => subMatchPush(event, updateMatch, isSub)

  return [event, subMatch]
}
